import { Observable } from 'rxjs'
import { Wishlist } from '../../models'

export abstract class MbWishlistAdapter {

  abstract loadDefaultWishlist (userId: string): Observable<Wishlist>

  abstract addEntryToWishlist (productCode: string, userId: string): Observable<Wishlist>

  abstract removeEntryFromWishlist (productCode: string, userId: string): Observable<Wishlist>
}
